import React, { useEffect, useState } from "react";
import { Box, TextField, Grid, Paper, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { deleteTrailUser, updateTrailUser } from "../../api/trialUsers";
import { showAlert } from "../../actions/alert";
import DeleteDialog from "../../component/DeleteDialogDetailPage";
import { handleAxiosError } from "../../config/action-config";

export default function ViewTrialUser({ preloadedValues, refresh }) {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: preloadedValues });

  async function onTrialUserUpdate(newdata) {
    try {
      const { data } = await updateTrailUser(params.id, newdata, user.token);
      refresh();
      // loadMasterData();
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  const onDelete = () => {
    deleteTrailUser(params.id, user.token)
      .then((res) => {
        if (res.data.status == true) {
          navigate(-2);
          dispatch(showAlert(res.data.message));
        } else {
          dispatch(showAlert(res.data.message));
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Trial User Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            {/* <Button
              disabled={/^Trial_User$/i.test(user.role) ? true : false}
              variant="contained"
              onClick={() => {
                setEditDisabled((prev) => !prev);
              }}
              style={{ padding: "5px 7px" }}
            >
              {editDisabled ? "Edit" : "Cancel"}
            </Button> */}
            <Button
              variant="contained"
              onClick={() => {
                setOpen(true);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <TextField
              name="email"
              fullWidth
              label="Email"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Email is required.",
              })}
              required
              error={Boolean(errors.email)}
              helperText={errors.email?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <TextField
              name="firstname"
              fullWidth
              label="First Name"
              className="name-textfeild"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "First Name is required.",
              })}
              required
              error={Boolean(errors.firstname)}
              helperText={errors.firstname?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <TextField
              name="lastname"
              fullWidth
              label="Last Name"
              className="name-textfeild"
              type="text"
              variant="outlined"
              inputRef={register({
                required: false,
              })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <TextField
              name="contact"
              fullWidth
              label="Contact"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Contact Number is required.",
              })}
              required
              error={Boolean(errors.contact)}
              helperText={errors.contact?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <TextField
              name="company"
              fullWidth
              label="Company"
              inputRef={register({
                required: "Company is required.",
              })}
              required
              error={Boolean(errors.company)}
              helperText={errors.company?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <TextField
              name="address"
              fullWidth
              label="Address"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Address is required.",
              })}
              required
              error={Boolean(errors.address)}
              helperText={errors.address?.message}
            />
          </Grid>
        </Grid>
      </Paper>
      <br />

      <DeleteDialog open={open} setOpen={setOpen} onDelete={onDelete} />
    </Box>
  );
}
